/**
 * The ProxyUrl class provides a way to use URL preventing issues of CORS
 */
export class ProxyUrl {
  static _proxyUrl = '';

  /**
   * Set the proxied Url
   */
  static setProxy(proxy) {
    ProxyUrl._proxyUrl = proxy;
  }

  /**
   * Disables the logger, preventing any log messages from being processed.
   */
  static getProxiedUrl(url) {
    if(!ProxyUrl._proxyUrl) {
      return url;
    }
    return `${ProxyUrl._proxyUrl}/${url}`
  }

}